import type { ReactNode } from 'react';
import { type RegionMappings, RegionMappingsContext } from './region-mappings-context';

/**
 * Las tablas `Locale` → BCP 47 y `Timezone` → IANA las tiene el código existente (`utils/i18n`), que
 * `fsd/` no puede importar. `FsdContext` las inyecta acá; en los tests va una tabla de prueba.
 */
export function RegionMappingsProvider({
  mappings,
  children,
}: {
  mappings: RegionMappings;
  children: ReactNode;
}) {
  return (
    <RegionMappingsContext.Provider value={mappings}>{children}</RegionMappingsContext.Provider>
  );
}
